var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z",
    fill: "#809DDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66534 13.6868L5.94725 10.985C5.87129 10.9091 5.83331 10.8114 5.83331 10.692C5.83331 10.5727 5.87129 10.475 5.94725 10.3991L6.54946 9.81315C6.62541 9.72634 6.72036 9.68294 6.83429 9.68294C6.94822 9.68294 7.04859 9.72634 7.13539 9.81315L8.95831 11.6361L12.8645 7.72982C12.9514 7.64301 13.0517 7.59961 13.1657 7.59961C13.2796 7.59961 13.3745 7.64301 13.4505 7.72982L14.0527 8.31575C14.1286 8.39171 14.1666 8.48936 14.1666 8.60872C14.1666 8.72808 14.1286 8.82573 14.0527 8.90169L9.25127 13.6868C9.17532 13.7736 9.07766 13.817 8.95831 13.817C8.83895 13.817 8.74129 13.7736 8.66534 13.6868Z",
    fill: "#809DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.7706e45e2e151ec13468c94f3a67717c.svg";
export { ForwardRef as ReactComponent };